module.exports = __webpack_public_path__ + "img/1-1.51300a7c.png";